import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

export interface Address {
  id: number,
  isMain: boolean,
  person: number,
  alias: string,
  zip: string,
  country: string,
  state: string,
  city: string,
  street: string,
  number: string,
  district: string,
  complement: string,
  latitude: number,
  longitude: number
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface AddressState {
  readonly address?: Address
  readonly addresses: Address[]
}

/**
* Action Data
*/

export interface AddressData {
  alias: string,
  zip: string,
  country: string,
  state: string,
  city: string,
  street: string,
  number: string,
  district: string,
  complement: string,
  latitude: number,
  longitude: number
}

/**
* Action Enum Types
*/

export enum AddressTypes {
  ADDRESS_CREATE = 'ADDRESS/CREATE',
  ADDRESS_UPDATE = 'ADDRESS/UPDATE',
  ADDRESS_DELETE = 'ADDRESS/DELETE',
  ADDRESS_GET = 'ADDRESS/GET',
  ADDRESS_GET_LIST = 'ADDRESS/GET/LIST',
}

/**
* Action Types
*/
interface CreateAction {
  type: typeof AddressTypes.ADDRESS_CREATE,
  payload: Address
}

interface UpdateAction {
  type: typeof AddressTypes.ADDRESS_UPDATE,
  payload: Address
}

interface DeleteAction {
  type: typeof AddressTypes.ADDRESS_DELETE,
  payload: number
}

interface GetAction {
  type: typeof AddressTypes.ADDRESS_GET,
  payload: Address
}

interface GetListAction {
  type: typeof AddressTypes.ADDRESS_GET_LIST,
  payload: Address[]
}

export type AddressActionTypes = (
  AlertActionTypes | CreateAction | UpdateAction | DeleteAction | GetAction | GetListAction
)
